module.exports = __webpack_public_path__ + "img/ic_private_sales.27a4f6a9.svg";